import script from "./InventoryLogisticsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryLogisticsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./InventoryLogisticsSidebar.vue?vue&type=style&index=0&id=66927248&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66927248"]])

export default __exports__